import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const StarCheck: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 24 24" {...props}>
    <path d="M10 0L13.0372 3.69322L17.8183 3.7651L16.8245 8.44235L19.7493 12.2252L15.4728 14.3644L14.3388 19.0097L10 17L5.66116 19.0097L4.52718 14.3644L0.250721 12.2252L3.1755 8.44235L2.18168 3.7651L6.96281 3.69322L10 0Z" />
    <path
      d="M8.75007 11.7374L7.01257 9.99993L6.4209 10.5874L8.75007 12.9166L13.7501 7.9166L13.1626 7.3291L8.75007 11.7374Z"
      fill="white"
    />
  </BlueprintIcon>
);
